export const PAGE_PATH = '/winners';
